var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_57201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 2.1943C0.277344 1.0493 1.20555 0.121094 2.35054 0.121094C3.49554 0.121094 4.42374 1.0493 4.42374 2.19429V20.5642H0.277344V2.1943Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.277344 15.8232C0.277344 14.6782 1.20555 13.75 2.35054 13.75C3.49554 13.75 4.42374 14.6782 4.42374 15.8232V20.5644H0.277344V15.8232Z",
    fill: "#63658E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_742_57201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.85547 2.35254C7.85547 1.18055 8.80555 0.230469 9.97754 0.230469C11.1495 0.230469 12.0996 1.18055 12.0996 2.35254V20.6735H7.85547V2.35254Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85547 18.7119C7.85547 17.5399 8.80555 16.5898 9.97754 16.5898C11.1495 16.5898 12.0996 17.5399 12.0996 18.7119V20.6785H7.85547V18.7119Z",
    fill: "#63658E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_742_57201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 2.32009C15.5391 1.16602 16.4746 0.230469 17.6287 0.230469C18.7827 0.230469 19.7183 1.16602 19.7183 2.32008V20.6735H15.5391V2.32009Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 9.13649C15.5391 7.98243 16.4746 7.04688 17.6287 7.04688C18.7827 7.04688 19.7183 7.98243 19.7183 9.13649V20.6756H15.5391V9.13649Z",
    fill: "#63658E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_57201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.56104,
    height: 20.3492,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_742_57201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.38561,
    height: 20.3492,
    fill: "white",
    transform: "translate(7.71875 0.109375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_742_57201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.73646,
    height: 20.3492,
    fill: "white",
    transform: "translate(15.2617 0.109375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/lineChart.8cd8eaf9b02883de7c91e9ce0e096f33.svg";
export { ForwardRef as ReactComponent };